export const PERMS = {
    READ: 'invoicing_received_invoices.read',
    UPDATE: 'invoicing_received_invoices.update',
    DELETE: 'invoicing_received_invoices.delete',
    RESTORE: 'invoicing_received_invoices.restore',
    CREATE: 'invoicing_received_invoices.create',
    EXPORT: 'invoicing_received_invoices.export',
    EXPORT_TO_ACCOUNTING: 'invoicing_received_invoices.export_to_accounting',
}
